import { render, staticRenderFns } from "./BovinesMap.vue?vue&type=template&id=20357fd8"
import script from "./BovinesMap.vue?vue&type=script&lang=js"
export * from "./BovinesMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports